import { useState, useEffect } from 'react';
import { Background, Form, Title, Button, CloseIcon } from './style';
import InputLabel from '../../InputLabel';
import { userId } from '../../../services/TokenData';
import TextareaLabel from '../../TextareaLabel';
import api from '../../../services/api';
import { format } from '../../../services/DateFormatter';
import alert from '../../../utils/alert'

export default function SolicitacaoTempo({ Show, setShow, DadosOcorrencia, Reload, setReload, DadosProcesso }) {
    const [Motivo, setMotivo] = useState('');
    const [QuantDias, setQuantDias] = useState(0);
    // const [IdSolicitante, setIdSolicitante] = useState(null);
    const [IdDestinatario, setIdDestinatario] = useState(null);
    const [DataPrevista, setDataPrevista] = useState(format({ DataConclusao: new Date(), format: 'YYYY-MM-DD' }));
    useEffect(() => {
        setDataPrevista(DadosOcorrencia?.data_prevista);
    }, [Show]);

    async function HandleSubmit(e) {
        e.preventDefault();
        const data = {
            justificativa_solicitacao: Motivo,
            quantidade_dias: Number(QuantDias),
            id_processo: DadosOcorrencia.id_processo,
            seq_ocorrencia: DadosOcorrencia.seq_ocorrencia,
            nivel_ocorrencia: DadosOcorrencia.nivel_ocorrencia,
            id_solicitante: userId(),
            id_destinatario: DadosOcorrencia.id_remetente,
        };
        api.post(`/solicitacoes`, { data })
            .then((response) => {             
                alert('Sucesso-popup', `Solicitação de prorrogação de prazo enviada com sucesso!`, 3000, '', '', 'top-end', 'fit-content')
            })
            .catch((e) => {                
                alert('Erro-popup', `Erro ao enviar solicitação de ${data.nivel_ocorrencia !== 0 ? 'subocorrência' : 'ocorrência'} !`, 3000, '', '', 'top-end', 'fit-content')
                console.erro(e)
            });
        api.post(`/user/mail_solicitacao/${'operador'}`, { data });
        Close();
        setReload(!Reload);
    }

    async function Close() {
        setMotivo('');
        setIdDestinatario(0);
        setQuantDias(0);
        setShow(false);
    }

    return (
        <Background Show={Show}>
            <Form onSubmit={HandleSubmit}>
                <CloseIcon onClick={() => Close()} />
                <Title>Solicitação de Novo Prazo</Title>
                <TextareaLabel
                    value={Motivo}
                    onChange={(e) => setMotivo(e.target.value)}
                    label="Motivo"
                    id={'motivo-solicitacao'}
                    required
                    maxLength={130}
                />
                <InputLabel type="number" value={QuantDias} onChange={(e) => setQuantDias(e.target.value)} label="Dias necessarios:" required />
                <Button type="submit">Salvar</Button>
            </Form>
        </Background>
    );
}
